"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_ui_1 = require("@newfront-insurance/core-ui");
var react_1 = __importDefault(require("react"));
function PolicyChangeStatusSelector(props) {
    var _a = props.defaultValue, defaultValue = _a === void 0 ? 'Pending' : _a, value = props.value, onChange = props.onChange, _b = props.disabled, disabled = _b === void 0 ? false : _b, isRequired = props.isRequired;
    var options = [
        {
            label: 'Pending',
            value: 'Pending',
        },
        {
            label: 'Confirmed',
            value: 'Confirmed',
        },
        {
            label: 'Cancelled',
            value: 'Cancelled',
        },
    ];
    return (react_1.default.createElement(core_ui_1.SelectInput, { name: "Status", options: options, onChange: function (option) {
            if (onChange)
                onChange(option);
        }, defaultValue: defaultValue, value: value, disabled: disabled, showSelectAnOption: !isRequired }));
}
exports.default = PolicyChangeStatusSelector;
